import { css } from '@emotion/css';

import { type GrafanaTheme2, renderMarkdown } from '@grafana/data';
import { t } from '@grafana/i18n';
import { Box, IconButton, useStyles2 } from '@grafana/ui';

import { type Spec } from '../api/clients/banners/v0alpha1';

type Props = Pick<Spec, 'message' | 'variant'> & {
  // Renders a close button when provided
  onDismiss?: () => void;
};

export function Banner({ message, variant, onDismiss }: Props) {
  const styles = useStyles2(getStyles);

  return (
    <Box
      display="flex"
      backgroundColor={variant}
      borderRadius="default"
      paddingY={1}
      paddingX={2}
      gap={2}
      alignItems="center"
    >
      <div className={styles.content}>
        <div dangerouslySetInnerHTML={{ __html: renderMarkdown(message) }} />
      </div>
      {onDismiss && (
        <IconButton name="times" onClick={onDismiss} tooltip={t('banner.dismiss.tooltip-close', 'Close banner')} />
      )}
    </Box>
  );
}

function getStyles(theme: GrafanaTheme2) {
  return {
    content: css({
      flexGrow: 1,
      p: {
        margin: 0,
      },
      a: {
        color: theme.colors.text.link,
      },
    }),
  };
}
